



























import Vue from 'vue'
import {
  SearchHistory,
  searchHistoryToReadableString,
  Area,
} from '@/core/Facilities'
import { Activity } from '@/core/Activities'

export default Vue.extend({
  name: 'SearchHistoryList',
  props: {
    histories: {
      type: Array as () => (SearchHistory | string)[],
      default: () => [],
    },
    areas: {
      type: Array as () => Area[],
      default: () => [],
    },
    activities: {
      type: Array as () => Activity[],
      default: () => [],
    },
  },
  computed: {
    readableHistories(): string[] {
      return this.histories.map((history: string | SearchHistory) =>
        typeof history === 'string'
          ? history
          : searchHistoryToReadableString(history, this.areas, this.activities)
      )
    },
  },
  methods: {
    onClick(history: string | SearchHistory) {
      this.$emit('click', history)
    },
  },
})
